export type instituteRecordInfo = {
  overview: boolean;
  headlines: boolean;
  contacts: boolean;
  'investment-appetite': boolean;
  'fund-commitment': boolean;
  'funds-managed': boolean;
};
export type instituteProp = {
  institute: string;
  institutionId: string;
  partnerStatus: string;
  isECJest: boolean;
  recordsInfo: instituteRecordInfo;
  user: userProp;
};
export type userProp = {
  name: string;
  loggedIn: boolean;
  customerId: string;
};
export const initialState: instituteProp = {
  institute: 'Institution Name',
  institutionId: '',
  partnerStatus: '',
  isECJest: false,
  recordsInfo: {
    overview: false,
    headlines: false,
    contacts: false,
    'investment-appetite': false,
    'fund-commitment': false,
    'funds-managed': false,
  } as instituteRecordInfo,
  user: {
    name: '',
    loggedIn: false,
    customerId: '',
  },
};

export const instituteReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'setInstitute':
      return { ...state, institute: action.payload };
    case 'setPartnerStatus':
      return { ...state, partnerStatus: action.payload };
    case 'setInstituteAndPartnerStatus':
      return {
        ...state,
        partnerStatus: action.payload.partnerStatus,
        institute: action.payload.institute,
        institutionId: action.payload.institutionId,
      };
    case 'setRecordInfo':
      const recordsInfo = {
        [action.payload.key as keyof instituteRecordInfo]: action.payload.value,
      };
      return {
        ...state,
        recordsInfo: { ...state.recordsInfo, ...recordsInfo },
      };
    case 'setUser':
      return {
        ...state,
        user: { ...state.user, ...action.payload },
      };
    default:
      return { ...state };
  }
};
